import type { GeometryPadWidgetConfig } from '../geometrypad.model';

/**
 * Parallelogram with diagonal and altitude features.
 *
 * Verifiable properties:
 * - Diagonals bisect each other
 * - Altitude length = s * sin(angle)
 * - Area = b * h
 */
export const PARALLELOGRAM_FEATURES_PRESET: GeometryPadWidgetConfig = {
  id: 'parallelogram-features',
  type: 'geometrypad',
  params: {
    elements: {
      pg1: {
        type: 'Parallelogram',
        params: { b: 6, s: 4, angle: 60 },
      },
      'diagonal.pg1': { type: 'Diagonal', params: { of: 'pg1' } },
      'altitude-D.pg1': { type: 'Altitude', params: { of: 'pg1', from: 'D' } },
    },
  },
  display: {},
};
